import EFPicture from 'elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_220w_single');

    return (
        <div className="sp-220-single-B">
            <div className="pc features">
                <div className="box l">
                    <EFPicture src={'/responsive/picture/solar-panel-220w-single/2_1.jpg'} alt={t('B_1_text')} />
                    <div className="box-text">
                        {t.rich('B_1_text', {
                            s: (text: string) => <p className="small-text">{text}</p>,
                        })}
                    </div>
                </div>
                <div className="r">
                    <div className="r-t">
                        <div className="r-t-l box">
                            <EFPicture src={'/responsive/picture/solar-panel-220w-single/2_2.jpg'} alt={t('B_2_text')} />
                            <div className="box-text">
                                {t.rich('B_2_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                        <div className="r-t-r box">
                            <EFPicture src={'/responsive/picture/solar-panel-220w-single/2_3.jpg'} alt={t('B_3_text')} />
                            <div className="box-text">
                                {t.rich('B_3_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="r-b">
                        <div className="r-b-l box">
                            <EFPicture src={'/responsive/picture/solar-panel-220w-single/2_4.jpg'} alt={t('B_4_text')} />
                            <div className="box-text">
                                {t.rich('B_4_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                        <div className="r-b-r box">
                            <EFPicture src={'/responsive/picture/solar-panel-220w-single/2_5.jpg'} alt={t('B_5_text')} />
                            <div className="box-text black">
                                {t.rich('B_5_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="h5 features">
                <div className="left">
                    <div className="left-top box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-single/2_1_768.jpg'} alt={t('B_1_text')} />
                        <div className="box-text">
                            {t.rich('B_1_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                    <div className="left-bottom box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-single/2_5_768.jpg'} alt={t('B_5_text')} />
                        <div className="box-text black">
                            {t.rich('B_5_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                </div>
                <div className="right">
                    <div className="right-top box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-single/2_2_768.jpg'} alt={t('B_2_text')} />
                        <div className="box-text">
                            {t.rich('B_2_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                    <div className="right-middle box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-single/2_4_768.jpg'} alt={t('B_4_text')} />
                        <div className="box-text">
                            {t.rich('B_4_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                    <div className="right-bottom box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-single/2_3_768.jpg'} alt={t('B_3_text')} />
                        <div className="box-text">
                            {t.rich('B_3_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
